<template>
  <div class="p-6">
    <div class="mx-auto bg-natural-soft-white rounded-full flex justify-center items-center w-[60px] h-[60px]">
      <TsIcon class="text-info" name="mdi:store-clock-outline" size="32" />
    </div>
    <TsIcon class="text-idle-black cursor-pointer absolute top-6 right-6 !size-7" name="charm:cross"
    @click="closeModal" />

    <TsTypography variant="h2" weight="semibold" append-class="text-idle text-center text-idle-black mt-2">{{ useTranslation("nextDayCollection", "Ophalen de volgende dag") }}</TsTypography>
    <TsColumn append-class="p-0 my-4">
      <TsTypography weight="semibold">
        {{ useTranslation("PDP-modal-nextDayCollectionInfo1", "Artikelen zijn beschikbaar voor de volgende") }}
        <span class="text-idle-black">{{ useTranslation("PDP-modal-nextDayCollection1-subText1","werkdag ophalen") }}</span> 
        {{ useTranslation("PDP-modal-nextDayCollection1-subText2", "in tak")}}.
      </TsTypography>
      <TsTypography append-class="mt-2 text-idle-black" weight="semibold">
        {{ useTranslation("PDP-modal-nextDayCollectionInfo2", "Bestellingen die op donderdag na 21.00 uur en op zondag vóór 18.00 uur worden geplaatst, kunnen op maandag worden opgehaald.") }}
      </TsTypography>
      <TsTypography append-class="mt-2 text-idle-black" weight="semibold">
        {{ useTranslation("PDP-modal-nextDayCollectionInfo3", "Voor artikelen zwaarder dan 30 kg geldt een levertijd van twee werkdagen.") }}
      </TsTypography>
      <TsTypography append-class="mt-2" weight="semibold">
        {{ useTranslation("PDP-modal-nextDayCollectionInfo4", "Wij laten u weten wanneer wij uw bestelling kunnen ophalen. Vervolgens bewaren wij uw artikelen 14 dagen lang.") }}
      </TsTypography>
    </TsColumn>

    <TsButton append-class="mt-4" :label="useTranslation('okay','Oké')" block variant="info" @click="closeModal()" data-testid="next-day-collection-info-okay-btn" />
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";

const productStore = useProductStore();

const closeModal = () => {
  productStore.isNextDayCollectionInfoModalVisible = false;
};
</script>